import React from "react";

// Assets
import {
  ErrorBannerDesktop,
  ErrorBannerMobile,
  LoginBannerDesktop,
  LoginBannerMobile,
  SignupBannerDesktop,
  SignupBannerMobile,
  SuccessBannerDesktop,
  SuccessBannerMobile,
  UpdateBannerDesktop,
  UpdateBannerMobile,
} from "~/assets";
// Hooks
import { useBreakpoint } from "~/shared";

export const BannerTypes = {
  login: "login",
  signup: "signup",
  forgotPassword: "forgotPassword",
  resetPassword: "resetPassword",
  accountVerified: "accountVerified",
  notFound: "notFound",
  crashError: "crashError",
  pendingVerification: "pendingVerification",
  codeValidation: "codeValidation",
} as const;

export type AuthBannerTypes =
  | "signup"
  | "login"
  | "forgotPassword"
  | "resetPassword"
  | "accountVerified"
  | "notFound"
  | "crashError"
  | "pendingVerification"
  | "codeValidation";

type AuthBannerProps = {
  type: AuthBannerTypes;
};

const AuthBanner = ({ type }: AuthBannerProps) => {
  const { isMobile } = useBreakpoint();
  const bannerForAuthView: Record<AuthBannerTypes, string> = {
    signup: isMobile ? SignupBannerMobile : SignupBannerDesktop,
    login: isMobile ? LoginBannerMobile : LoginBannerDesktop,
    forgotPassword: UpdateBannerMobile,
    resetPassword: isMobile ? UpdateBannerMobile : UpdateBannerDesktop,
    accountVerified: isMobile ? SuccessBannerMobile : SuccessBannerDesktop,
    notFound: isMobile ? ErrorBannerMobile : ErrorBannerDesktop,
    crashError: isMobile ? ErrorBannerMobile : ErrorBannerDesktop,
    pendingVerification: isMobile ? UpdateBannerMobile : UpdateBannerDesktop,
    codeValidation: isMobile ? UpdateBannerMobile : UpdateBannerDesktop,
  };
  return (
    <img
      src={bannerForAuthView[type]}
      className="shrink-1 h-auto max-h-[80dvh] w-full object-cover"
      alt=""
    />
  );
};

export default AuthBanner;
